import { html } from 'lit';
import { Mail } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-mail')
export class PdsIconMail extends PdsIcon {
  @state()
  icon = Mail;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
